'use client'

import { useState } from 'react'
import { Button } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useSession } from '@marketplace-web/shared/session-data'
import { useAuthModal } from '@marketplace-web/registration/identity-feature'

import { ConversationInitiatorType } from '@marketplace-web/messaging/conversation-messaging-data'
import { useCreateConversation } from '@marketplace-web/messaging/conversation-messaging-api-resolvers-feature'

import { ItemPageMakeOfferActionPluginModel } from '../types'
import ItemBuyerOfferModal from '../ItemBuyerOfferModal/ItemBuyerOfferModal'

type Props = {
  data: ItemPageMakeOfferActionPluginModel
}

export const ItemBuyerOfferModalContainer = ({ data }: Props) => {
  const { itemId, itemTitle, itemThumbnailUrl, price, sellerId, currency } = data

  const [isOfferModalOpen, setIsOfferModalOpen] = useState(false)

  const translate = useTranslate('item.actions')
  const { openAuthModal } = useAuthModal()

  const { user } = useSession()
  const isAuthenticated = !!user

  const itemIdStringified = itemId.toString()
  const sellerIdStringified = sellerId.toString()

  const { conversation, createConversation } = useCreateConversation()

  const handleOfferModalOpen = () => {
    if (isAuthenticated) {
      setIsOfferModalOpen(true)

      createConversation({
        itemId,
        receiverId: sellerIdStringified,
        initiator: ConversationInitiatorType.BuyerEntersOfferForm,
      })

      return
    }

    openAuthModal()
  }

  const handleOfferModalClose = () => setIsOfferModalOpen(false)

  return (
    <>
      <Button
        text={translate('offer_request')}
        onClick={handleOfferModalOpen}
        testId="item-buyer-offer-button"
      />
      {isAuthenticated && (
        <ItemBuyerOfferModal
          isOpen={isOfferModalOpen}
          itemInfo={{
            itemId: itemIdStringified,
            itemIds: [itemId],
            itemTitle,
            itemThumbnailUrl,
            itemPrice: price,
            sellerId,
          }}
          currency={currency}
          onClose={handleOfferModalClose}
          conversation={conversation}
        />
      )}
    </>
  )
}
